import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {observable, Observable} from 'rxjs';
import {Configuration} from './configuration';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private isLocal = false;
  // private apiHost = this.isLocal ? 'http://localhost:10000' : 'http://services-core.aqaix.com:10000';
  // private apiHost = this.isLocal ? 'http://localhost:10000' : 'https://service-configuration.aqaix.com';
  private apiHost = this.isLocal ? 'http://localhost-aqaix-apistore.aqaix.com:10000' : 'https://service-configuration.aqaix.com';
  // private apiHost = this.isLocal ? 'http://localhost-aqaix-apistore.aqaix.com:10000' : 'https://h2otower-service-configuration.aqaix.com';
  private resourceConfiguration = this.apiHost + '/configuration';
  private configuration: Configuration;

  constructor(private http: HttpClient) {
  }

  getConfigurationObservable(): Observable<Configuration> {
    return (this.http.get<Configuration>(this.resourceConfiguration, {withCredentials: true}));
  }

  getConfigurationPromise() {
    return this.getConfigurationObservable().toPromise()
      .then( configuration => {
        this.configuration = configuration;
      });
  }

  getConfiguration(): Configuration {
    return (this.configuration);
  }
}
